"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomLabelsEditor = void 0;
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var CustomLabelsEditor = (function () {
    function CustomLabelsEditor(createUi, usingFeature, labelSet, labelService, overlayStack, onDone) {
        var _this = this;
        var defaultFields = labelService.getDefaultFields();
        var fieldOrder = [
            Types_1.QuoteLabel.Section,
            Types_1.QuoteLabel.Total,
            Types_1.QuoteLabel.SubTotal,
            Types_1.QuoteLabel.ExcludingTax,
            Types_1.QuoteLabel.Discount,
            Types_1.QuoteLabel.PercentageOff,
            Types_1.QuoteLabel.Description,
            Types_1.QuoteLabel.Item,
            Types_1.QuoteLabel.Quantity,
            Types_1.QuoteLabel.Price,
            Types_1.QuoteLabel.Per,
            Types_1.QuoteLabel.Select,
            Types_1.QuoteLabel.Selected,
            Types_1.QuoteLabel.Recommended,
            Types_1.QuoteLabel.OneOffAdjective,
            Types_1.QuoteLabel.DueToday,
            Types_1.QuoteLabel.DueTodayExcludingTax,
            Types_1.QuoteLabel.OneOff,
            Types_1.QuoteLabel.Recurring,
            Types_1.QuoteLabel.WeekNoun,
            Types_1.QuoteLabel.WeekAdjective,
            Types_1.QuoteLabel.MonthNoun,
            Types_1.QuoteLabel.MonthAdjective,
            Types_1.QuoteLabel.QuarterNoun,
            Types_1.QuoteLabel.QuarterAdjective,
            Types_1.QuoteLabel.YearNoun,
            Types_1.QuoteLabel.YearAdjective,
        ];
        if (usingFeature(FeatureFlag_1.default.AgreementViewWidget)) {
            var insertIndex = fieldOrder.findIndex(function (field) { return field === Types_1.QuoteLabel.SubTotal; }) + 1;
            fieldOrder.splice(insertIndex, 0, Types_1.QuoteLabel.GrandTotal);
        }
        this.ui = createUi(require("./CustomLabelsEditor.html"), {
            name: labelSet.name,
            defaultFields: defaultFields,
            fieldOrder: fieldOrder,
            labels: labelSet.labels,
            done: function () {
                labelSet.name = _this.ui.name;
                return onDone(labelSet.id, labelSet);
            },
            goBack: overlayStack.closeCurrent,
            closeOverlay: overlayStack.closeAll,
        });
    }
    return CustomLabelsEditor;
}());
exports.CustomLabelsEditor = CustomLabelsEditor;
